// 허용값 저장 확인창의 '수정 N건' — 남아 있는 기존 값끼리의 상대 순서와 라벨만 비교한다.
// (절대 인덱스를 쓰면 앞의 값을 지웠을 때 뒤의 값이 전부 수정으로 잡힌다.)
// 테스트(node --test)가 require 로 읽으므로 CommonJS 로 내보낸다 (errorMessage.js 와 같은 관례).
function countUpdatedAllowedValues(initial, current) {
    const keptNow = current.filter(v => v.id != null);
    const keptOrig = initial.filter(o => keptNow.some(v => v.id === o.id));
    return keptNow.filter((v, i) => {
        const orig = keptOrig[i];
        return !orig || orig.id !== v.id || orig.label_key !== v.label_key;
    }).length;
}

module.exports = { countUpdatedAllowedValues };
